import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateConfirmationOfDuration from './CSSZSickLeaveCertificateConfirmationOfDuration';

interface Props extends BaseModalProps {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: () => void;
}

const CSSZSickLeaveCertificateConfirmationOfDurationModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal
			{...props}
			size={Size.LG}
			title='component.CSSZSickLeaveCertificateConfirmationOfDuration.modalTitle'>
			<CSSZSickLeaveCertificateConfirmationOfDuration
				item={props.item}
				patientId={props.patientId}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateConfirmationOfDurationModal;
